import { isWeixin } from './cookie'
import Cookies from 'js-cookie'

export function toLogin(url?: string) {
  const referUrl = url || location.href
  //rkhy.${hostName}/loginbak/index.html?cmd=login
  location.href = `//rkhy.cekid.com/loginbak/index.html?cmd=login&referer=${encodeURIComponent(
    referUrl
  )}`
}

// code返回方法
export const toH5Login = (referer?: string) => {
  location.href = `/rkhy/rkhy-recruitment/login?cmd=login&referer=${encodeURIComponent(
    decodeURIComponent(referer || location.href)
  )}`
}

export const toWxLogin = (referer?: string, isSignOutManual?: boolean) => {
  const redirectUri = encodeURIComponent(
    `https://w.cekid.com/hr/pre-employment/wxBridge?referer=${encodeURIComponent(
      decodeURIComponent(
        referer ||
          'https://jobs.cekid.com/rkhy/rkhy-recruitment/recruitment?type=social'
      )
    )}&buzzType=1${isSignOutManual ? '&unloginWay=1' : ''}`
  )
  location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd4b691f33e9f2a75&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`
}

export const toCLogin = (referer?: string, isSignOutManual?: boolean) => {
  if (isWeixin()) {
    toWxLogin(referer, isSignOutManual)
  } else {
    Cookies.remove('ehrUid', {
      domain: '.cekid.com'
    })
    toH5Login(referer)
  }
}
